import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import './imageViewerStyling.css';

export default function RadioGroupRating({ value, onValueChange }) {
  const [hover, setHover] = useState(-1);

  const circleClasses = ["circle-1", "circle-2", "circle-3", "circle-4", "circle-5", "circle-0"];

  const handleRatingClick = (index) => {
    const newRating = index;
    onValueChange(value === newRating ? null : newRating);
  };  

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '4px',
        paddingLeft: '4px'
      }}
    >
      {circleClasses.map((val, index) => (
        <div
          key={index}
          className={`circle ${val} ${value === index ? "selected" : ""}`}
          onMouseEnter={() => setHover(index)}
          onMouseLeave={() => setHover(-1)}
          onClick={() => handleRatingClick(index)}
        >
          {index === 0 ? '?' : index}
        </div>
      ))}
    </Box>
  );
}

RadioGroupRating.propTypes = {
  value: PropTypes.number,
  onValueChange: PropTypes.func.isRequired,
};
